export const track = (params) => {
  if (_hmt) {
    _hmt.push(['_trackEvent', ...params]);
  }
};



// WEBPACK FOOTER //
// ./src/components/util/track.js